import React from "react";
import {Button} from "primereact/button";

/** Page heading used on top of every tab (kicker, title, description, optional primary action). */
export function TabHeader({kicker, title, description, onNew}) {
    return (
        <div className="flex align-items-center justify-content-between gap-3 flex-wrap">
            <div>
                <div className="text-xs text-primary font-bold">{kicker}</div>
                <h2 className="m-0 mt-1">{title}</h2>
                <p className="m-0 mt-1 text-sm text-500">{description}</p>
            </div>
            {onNew && <Button className="text-xs" icon="pi pi-plus" label="محتوای جدید" onClick={onNew}/>}
        </div>
    );
}

export function Card({title, description, action, className = "", children}) {
    return (
        <section className={`surface-card border-1 border-200 border-round-xl p-3 ${className}`}>
            {(title || action) && (
                <div className="flex align-items-start justify-content-between gap-2 mb-3">
                    <div>
                        <h3 className="m-0 text-base">{title}</h3>
                        {description && <p className="m-0 mt-1 text-xs text-500">{description}</p>}
                    </div>
                    {action}
                </div>
            )}
            {children}
        </section>
    );
}

export function Note({children}) {
    return <div className="surface-100 border-round-lg p-3 mt-3 text-xs text-600">{children}</div>;
}
